import axios from "axios";
import toast from "react-hot-toast";

const ApiRoot = `${process.env.REACT_APP_RULES_API_ROOT}/itkcpdtype`;

async function getAllItkCpdTypesAsync() {
	try {
		const result = await axios.get(ApiRoot);
		return result.data;
	} catch {
		toast.error("Error listing ITK CPD types please try again");
		return [];
	}
}

export default getAllItkCpdTypesAsync;
